/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AlboUiProvider } from '@albo-ui/core';
import * as Material from '@mui/material';
import './global.css';
import './index.css';
import './App.css';

import * as Components from './components';
import { LeadProvider } from './contexts/LeadContext';
const App = (props) => {
  const [pos, setPos] = useState({});
  const [loader, setLoader] = useState(false);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#00e676',
        light: '#66ffa6',
        dark: '#00b248',
        contrastText: '#3743aa',
      },
      secondary: {
        main: '#3743aa',
        light: '#6e6edc',
        dark: '#001c7a',
        contrastText: '#ffffff',
      },
    },
    typography: {
      h6: {
        fontSize: '1em',
      },
    },
  });

  useEffect(() => {
    setLoader(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (a) => {
        localStorage.lat = a.coords.latitude;
        localStorage.lon = a.coords.longitude;
        let p = {
          lat: a.coords.latitude,
          lon: a.coords.longitude,
        };
        setPos(p);
        setLoader(false);
      });
      navigator.geolocation.watchPosition(async (a) => {
        localStorage.lat = a.coords.latitude;
        localStorage.lon = a.coords.longitude;
        let p = {
          lat: a.coords.latitude,
          lon: a.coords.longitude,
        };
        setPos(p);
        setLoader(false);
      });
      console.log("Geolocation is supported!");
    } else {
      console.log("Geolocation is not supported for this Browser/OS.");
    }
    setLoader(false);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Material.CssBaseline />
      <AlboUiProvider>
       <LeadProvider>
        <>
          {loader && <Components.Loader />}
          <div id="lightbox" className="lightboxHide"/>

          {!loader && (
            <Router>
              <Switch>
                <Route
                  path={"/login"}
                  exact
                  render={() => (
                    <Components.Login firebase={props.firebase} pos={pos} />
                  )}
                />
                <Route
                  path={"/"}
                  exact
                  render={() => (
                    <Components.Root firebase={props.firebase} pos={pos} />
                  )}
                />
              </Switch>
            </Router>
          )}
        </>
        </LeadProvider> 
      </AlboUiProvider>
    </ThemeProvider>
  );
};

export default App;
